import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-first-configuration',
  templateUrl: './first-configuration.component.html',
  standalone: false
})
export class FirstConfigurationComponent {
  goToConfiguration(): void {
    const returnUrl = window.location.origin;
    const url = new URL(environment.adminPanelUrl);
    url.searchParams.set('returnUrl', returnUrl);
    window.location.href = url.toString();
  }
}
